<script>
    import {COLORS} from "../../lib/constants";
    import {clickOutside} from '../../lib/clickOutside.js';
    import {randomColor} from "../../lib/lib";

    export let value = null;

    let showDropdown = false;

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const openDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        }
    }

    const closeDropdown = () => {
        if (showDropdown) {
            showDropdown = false;
            document.removeEventListener('keydown', handleEscapeKey);
        }
    }

    const onSelect = (color) => {
        value = color;
        closeDropdown();
    }

    if (!value) {
        value = randomColor();
    }
</script>
<span class="input-group-text color-group-control" use:clickOutside on:click_outside="{ closeDropdown }">
    <div class="color" style="background: #{value};" on:click="{ openDropdown }"></div>
    {#if showDropdown}
        <div class="dropdown">
            {#each COLORS as color}
                <div class="color-option" style="background: #{color};" on:click="{ () => onSelect(color) }">
                </div>
            {/each}
        </div>
    {/if}
</span>

<style>
    .color-group-control {
        position: relative;
        width: 38px;
        cursor: pointer;
        padding: 0.375rem;
    }

    .color-group-control .color {
        width: 24px;
        height: 24px;
    }

    .color-group-control .dropdown {
        position: absolute;
        top: 0;
        right: calc(100% + 2px);
        width: 150px;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        padding: 10px;
        z-index: 5000;
    }

    .color-group-control .dropdown .color-option {
        float: left;
        width: 20%;
        height: 25px;
        border: 2px solid #FFF;
        cursor: pointer;
    }
</style>